function clean(value) {
  return String(value || '').trim();
}

export function buildNewlineHashList(transactions = []) {
  return transactions
    .map((transaction) => clean(transaction.txHash))
    .filter(Boolean)
    .join('\n');
}

export function buildHashWithOptionalToAddressList(transactions = []) {
  return transactions
    .map((transaction) => {
      const txHash = clean(transaction.txHash);
      const toAddress = clean(transaction.toAddress);

      if (!txHash) return '';
      return toAddress ? `${txHash}\t${toAddress}` : txHash;
    })
    .filter(Boolean)
    .join('\n');
}

export function buildCaseBuddyCreateCaseTsv(transactions = []) {
  return transactions
    .map((transaction) => {
      const txHash = clean(transaction.txHash);
      const toAddress = clean(transaction.toAddress);

      if (!txHash) return '';

      // Column B = transaction hash, Column D = To Address.
      return ['', txHash, '', toAddress].join('\t');
    })
    .filter(Boolean)
    .join('\n');
}

export function buildSuggestedLabelsExport(labels = []) {
  return labels
    .map((entry) => {
      const address = clean(entry.address);
      const label = clean(entry.label);
      return address && label ? `${address}\t${label}` : '';
    })
    .filter(Boolean)
    .join('\n');
}
